import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const navigate = useNavigate();

  return (
    <div className="auth-layout">
      <div className="auth-card" style={{ textAlign: 'center', maxWidth: 380 }}>

        {/* Logo grande sin texto de marca */}
        <div style={{ marginBottom: '0.5rem' }}>
          <img
            src="/logo.png"
            alt="Autonation"
            style={{
              width: 180, height: 180, objectFit: 'contain',
              margin: '0 auto', display: 'block',
              filter: 'drop-shadow(0 0 24px rgba(74,158,255,0.4))',
            }}
            onError={e => { e.target.style.display = 'none'; }}
          />
        </div>

        {/* TALLER MULTIMARCA — estilo autonation.com.ec */}
        <div style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 700,
          fontSize: '1.45rem',
          letterSpacing: '7px',
          textTransform: 'uppercase',
          background: 'linear-gradient(135deg, #1a3d7a 0%, #4a7cc8 40%, #b0c0d8 70%, #1a3d7a 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: '2rem',
        }}>
          TALLER MULTIMARCA
        </div>

        {/* Opciones */}
        <button
          onClick={() => navigate('/login?modo=cliente')}
          style={{
            display: 'flex', alignItems: 'center', gap: '1rem',
            width: '100%', padding: '1rem 1.25rem', marginBottom: '0.75rem',
            background: 'rgba(245,166,35,0.06)',
            border: '1px solid rgba(245,166,35,0.22)',
            borderRadius: 14, cursor: 'pointer', textAlign: 'left',
            transition: 'all 0.18s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(245,166,35,0.12)';
            e.currentTarget.style.borderColor = 'rgba(245,166,35,0.45)';
            e.currentTarget.style.transform = 'translateX(3px)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(245,166,35,0.06)';
            e.currentTarget.style.borderColor = 'rgba(245,166,35,0.22)';
            e.currentTarget.style.transform = 'translateX(0)';
          }}
        >
          <span style={{ fontSize: '1.9rem', lineHeight: 1 }}>🚗</span>
          <div>
            <div style={{ fontWeight: 700, color: 'var(--warning)', fontSize: '0.95rem', fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '0.05em' }}>
              SOY CLIENTE
            </div>
            <div style={{ fontSize: '0.75rem', color: 'var(--silver-dark)', marginTop: '0.15rem' }}>
              Consulta el estado de tu vehículo
            </div>
          </div>
          <span style={{ marginLeft: 'auto', color: 'var(--silver-dark)', fontSize: '1.2rem' }}>›</span>
        </button>

        <button
          onClick={() => navigate('/login?modo=empleado')}
          style={{
            display: 'flex', alignItems: 'center', gap: '1rem',
            width: '100%', padding: '1rem 1.25rem',
            background: 'rgba(74,158,255,0.05)',
            border: '1px solid rgba(74,158,255,0.18)',
            borderRadius: 14, cursor: 'pointer', textAlign: 'left',
            transition: 'all 0.18s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(74,158,255,0.1)';
            e.currentTarget.style.borderColor = 'rgba(74,158,255,0.4)';
            e.currentTarget.style.transform = 'translateX(3px)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(74,158,255,0.05)';
            e.currentTarget.style.borderColor = 'rgba(74,158,255,0.18)';
            e.currentTarget.style.transform = 'translateX(0)';
          }}
        >
          <span style={{ fontSize: '1.9rem', lineHeight: 1 }}>🔧</span>
          <div>
            <div style={{ fontWeight: 700, color: 'var(--accent)', fontSize: '0.95rem', fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '0.05em' }}>
              SOY DEL TALLER
            </div>
            <div style={{ fontSize: '0.75rem', color: 'var(--silver-dark)', marginTop: '0.15rem' }}>
              Recepción, mecánico, administración
            </div>
          </div>
          <span style={{ marginLeft: 'auto', color: 'var(--silver-dark)', fontSize: '1.2rem' }}>›</span>
        </button>

      </div>
    </div>
  );
}
